"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const headerColor = (props) => props.color ||
    (props.variant === 'main'
        ? props.theme.colors.primaryAccentDark
        : props.theme.colors.textDark);
const font = (props) => props.variant === 'main'
    ? props.theme.font.size.xxl
    : props.theme.font.size.l;
const StyledHeader = styled_components_1.default.h1 `
  color: ${headerColor};
  border-bottom: 1px solid ${headerColor};
  font-size: ${(props) => font(props).fontSize};
  font-weight: ${(props) => props.theme.font.weight.medium};
  line-height: ${(props) => font(props).lineHeight};

  padding-bottom: ${(props) => props.theme.spacing.xs};
  text-align: ${(props) => props.textAlign};
`;
const Header = (_a) => {
    var { variant = 'main', textAlign = 'left' } = _a, props = __rest(_a, ["variant", "textAlign"]);
    return (react_1.default.createElement(StyledHeader, Object.assign({ variant: variant, textAlign: textAlign }, props)));
};
exports.Header = Header;
exports.default = exports.Header;
